import { render, staticRenderFns } from "./sourceInfo.vue?vue&type=template&id=4d202dc9&scoped=true"
import script from "./sourceInfo.vue?vue&type=script&lang=js"
export * from "./sourceInfo.vue?vue&type=script&lang=js"
import style0 from "./sourceInfo.vue?vue&type=style&index=0&id=4d202dc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d202dc9",
  null
  
)

export default component.exports